import { Breadcrumbs as MuiBreadcrumbs, Stack, styled, Typography } from '@mui/joy';
import { Link } from 'react-router-dom';

import { brand } from '../../../theme/brand';

const CRUMB_TEXT_SX = { textWrap: 'nowrap', fontWeight: 'md', lineHeight: 'xs' } as const;

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? brand.ocean['250'] : brand.ocean['600'],
  textUnderlineOffset: '0.15em',
}));

const Breadcrumbs = ({
  currentPage,
  parentPage,
}: {
  currentPage?: string;
  parentPage?: { label: string; path: string };
}) => {
  return (
    <Stack
      sx={{
        py: '12px',
        px: 3,
        bgcolor: (theme) => theme.palette.background.surface,
        // Inside the bar, like Figma's stroke, so the bar stays 48px.
        boxShadow: (theme) => `inset 0 -1px 0 ${theme.palette.primary.outlinedBorder}`,
      }}
    >
      <MuiBreadcrumbs
        separator='/'
        sx={{
          p: 0,
          '--Breadcrumbs-gap': 'calc(var(--joy-spacing) * 0.5)',
          // The separator's 24px line sets the row height, as in Figma.
          lineHeight: 'md',
          ol: { flexWrap: 'nowrap', overflowX: 'auto', alignItems: 'flex-start' },
        }}
      >
        <Typography level='body-md' sx={CRUMB_TEXT_SX}>
          Diligence tools
        </Typography>
        {currentPage || parentPage ? (
          <StyledLink to='/project-screener' sx={CRUMB_TEXT_SX}>
            SmartScan
          </StyledLink>
        ) : (
          <Typography level='body-md' sx={CRUMB_TEXT_SX}>
            SmartScan
          </Typography>
        )}
        {parentPage && (
          <StyledLink to={parentPage.path} sx={CRUMB_TEXT_SX}>
            {parentPage.label}
          </StyledLink>
        )}
        {currentPage && (
          <Typography level='body-md' sx={CRUMB_TEXT_SX}>
            {currentPage}
          </Typography>
        )}
      </MuiBreadcrumbs>
    </Stack>
  );
};

export { Breadcrumbs };
